"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = void 0;
var labels = {
  he: {
    preview_book_open_last_page: 'לדף האחרון שקראת',
    remove_from_my_books: 'הסרה ממדף הספרים שבשימושך'
  },
  ar: {
    preview_book_open_last_page: 'للصفحة الأخيرة التي قرأتها',
    remove_from_my_books: 'للإزالة من رفّ كتبك'
  },
  en: {
    preview_book_open_last_page: 'Last page',
    remove_from_my_books: 'Remove from your books'
  }
};
exports.labels = labels;